'use client';
import * as StyledComponents from 'styled-components';
import styled, {
  css,
  keyframes,
  createGlobalStyle as createGlobalStyleOG,
  ThemeConsumer as SCThemeConsumer,
  ThemeContext as SCThemeContext,
} from 'styled-components';
import Theme from './types/theme';

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {
    name: string;
  }
}

export const createGlobalStyle = createGlobalStyleOG;

export { StyledComponents, css, keyframes };
export const ThemeContext = SCThemeContext as React.Context<Theme>;
export const ThemeConsumer = SCThemeConsumer as React.Consumer<Theme>;
export default styled;
